import mobile from 'is-mobile';
const mixin = (startValue = false, breakpoint = 600, header = false) => {
  return {
    data() {
      return {
        isMobile: startValue,
        mobileBreakpoint: breakpoint,
        checkHeader: header,
      };
    },
    beforeMount() {
      if (this.checkHeader) {
        this.isMobile = mobile();
      } else {
        window.addEventListener('resize', this.checkIsMobile);
        this.checkIsMobile();
      }
    },
    destroyed() {
      if (!this.checkHeader) {
        window.removeEventListener('resize', this.checkIsMobile);
      }
    },
    methods: {
      checkIsMobile() {
        this.isMobile = window.innerWidth <= this.mobileBreakpoint;
      },
    },
  };
};

export default mixin;
